import React from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import Element from './Element'

const ContentView = ({ elements, float }) => (
   <View float={float} width="100%">
      {elements.map(element => (
         <Element key={element.id} {...element} float={float} />
      ))}
   </View>
)

ContentView.propTypes = {
   elements: PropTypes.array,
   float: PropTypes.string
}

ContentView.defaultProps = {
   elements: [],
   float: 'left'
}

export default ContentView
